import React from "react";
import {connect} from "react-redux";
import EmailSettings from "../../EmailSettings";

function TicketEmailSettingsPage({event})
{
    return (
        <EmailSettings event={event} type={"ticket"} />
    );
}

const mapStateToProps = (store) => ({
    event: store.currentEvent
});

export default connect(mapStateToProps)(TicketEmailSettingsPage);
